import RequestService from "../../services/RequestService";
import FormBase from "../FormBase";
import FormFieldBase from "../../forms/FormFieldBase";
import ValidationBase, { ValidationType } from "../../forms/ValidationBase";
import Professional from '../../models/Professional'
import { RegiaoOptions } from "../../data/Regiao";
import { TipoCadastroMedicoAssistenteOptions } from "../../data/TipoCadastroMedicoAssistente";


export default class PersonalAddressDataForm implements FormBase {

    TypeRegistration: FormFieldBase;
    Region: FormFieldBase;
    MedicoTitularEquipe: FormFieldBase;
    MedicoTitularRetaguarda: FormFieldBase;

    constructor(typeRegistration: any, medicoTitularEquipe: string, medicoTitularRetaguarda: string, region: string) {
        this.TypeRegistration = new FormFieldBase(typeRegistration, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.MedicoTitularRetaguarda = new FormFieldBase(medicoTitularRetaguarda, [new ValidationBase("", ValidationType.CUSTOM)], ((value: any) => { return this.ValidateFieldCustomRetaguarda(value) }));
        this.MedicoTitularEquipe = new FormFieldBase(medicoTitularEquipe, [new ValidationBase("", ValidationType.CUSTOM)], ((value: any) => { return this.ValidateFieldCustomEquipe(value) }));
        this.Region = new FormFieldBase(region, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
    }


    ValidateFieldCustomEquipe(value: any): string {
        if (this.TypeRegistration.Value === "MedicoAssistenteEquipeCliECirur" && value === "") {
            return "O Campo é obrigatório."
        }
        else {
            return "";
        }
    }
    ValidateFieldCustomRetaguarda(value: any): string {
        if (this.TypeRegistration.Value === "MedicoAssistenteEquipeRetaguarda" && value === "") {
            return "O Campo é obrigatório."
        }
        else {
            return "";
        }
    }

    static NewInstance(): PersonalAddressDataForm {
        return new PersonalAddressDataForm("", "", "", "");
    }

    async CallInsertOrUpdateApi(Professional: Professional): Promise<any> {
        const dataJson = this.getJsonObjet();
        return RequestService.postCreateOrUpdateRequest(dataJson, Professional.Id);
    }

    ValidateToGoNextStep(): string {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        if (!formIsValid) {
            return "Por favor, preencha os dados obrigatórios."
        } else {
            return "";
        }
    }

    GetFieldByName(name: string): FormFieldBase {

        switch (name) {

            case "TypeRegistration":
                return this.TypeRegistration

            case "MedicoTitularEquipe":
                return this.MedicoTitularEquipe

            case "MedicoTitularRetaguarda":
                return this.MedicoTitularRetaguarda

            case "Region":
                return this.Region

            default:
                return new FormFieldBase("", []);
        }
    }

    getJsonObjet() {

        return {
            "ProfessionalId": 0,
            "RequestTypeRegistration": {
                "Id": TipoCadastroMedicoAssistenteOptions.find(r => r.value === this.TypeRegistration.Value)?.id,
                "Name": TipoCadastroMedicoAssistenteOptions.find(r => r.value === this.TypeRegistration.Value)?.text
            },
            "RequestType": {
                "Id": 2,
                "Name": 'Médico Assistente'
            },
            "RequestRegion": RegiaoOptions.find(r => r.value === this.Region.Value)?.id,
            "HeadTeamPhysician": this.MedicoTitularEquipe.Value,
            "RearHeadPhysician": this.MedicoTitularRetaguarda.Value,
        }
    }

}